import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useDownloadListState = () =>
  useStore(store => store.downloadList.state)
